/* eslint-disable no-unused-vars */
import React from 'react'
import * as S from './styles'
import TabItem from './TabItem'

const Tab = ({ children, ...props }) => {
  return <S.TabGroup {...props}>{children}</S.TabGroup>
}

export default Object.assign(Tab, { Item: TabItem })
